import styled from 'styled-components'
import QRCode from 'qrcode.react'
import { useTranslation } from 'react-i18next'
import { getWineContacts } from 'utils/wine'

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 33px 62px;
  height: 114px;
  box-sizing: border-box;
`
const Left = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`
const Right = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
`
const Label = styled.div`
  font-size: 19px;
  line-height: 140%;
  font-family: var(--typography-bold);
  color: var(--color-brand-red);
  margin-right: 24px;
`

const Contacts = styled.div`
  font-weight: 500;
  font-size: 20px;
  line-height: 140%;
  color: #121432;
  padding-top: 5px;
`

const ContactLine = styled.div``

const filterAndJoin = arr => arr.filter(Boolean).join(' | ')

const Footer = ({ product }) => {
  const { t } = useTranslation()

  const qrCodeLocation = product?.shortUrl ?? document.location.href

  const wine = product?.wine

  const contacts = getWineContacts(wine)
  const line1 = filterAndJoin([contacts.tradeName, contacts.website])
  const line2 = filterAndJoin([contacts.email, contacts.phone])

  return (
    <Wrapper>
      <Left>
        <Contacts>
          <ContactLine>{line1}</ContactLine>
          <ContactLine>{line2}</ContactLine>
        </Contacts>
      </Left>
      <Right>
        <Label>{t('wine.techlist.footer.qrCodeDesc')}</Label>
        <QRCode value={qrCodeLocation} size={54} />
      </Right>
    </Wrapper>
  )
}

export default Footer
